export default {
    title: "Aanbevelingen van adviseurs",
    noItems: "Geen aanbevelingen"
}